import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    // Prevent default behavior and stop propagation
    event.preventDefault()
    event.stopPropagation()
    
    // If clicking directly on checkbox, let it handle naturally
    if (event.target.tagName === 'INPUT') {
      return
    }

    // Find the checkbox within the clicked label
    const label = event.currentTarget
    const checkbox = label.querySelector('input[type="checkbox"]')
    
    if (checkbox) {
      // Toggle checkbox state
      checkbox.checked = !checkbox.checked
      
      // Find the visual container and icons
      const container = label.querySelector('.flex.items-center')
      const icons = label.querySelectorAll('.mr-2')
      
      if (checkbox.checked) {
        // Update container styles
        container.classList.remove('border-gray-300')
        container.classList.add('border-blue-500', 'bg-blue-50')
        
        // Show check icon, hide empty space
        icons.forEach(icon => {
          if (icon.tagName === 'svg') {
            icon.classList.remove('hidden')
          } else if (icon.classList.contains('w-5')) {
            icon.classList.add('hidden')
          }
        })
      } else {
        // Update container styles
        container.classList.remove('border-blue-500', 'bg-blue-50')
        container.classList.add('border-gray-300')
        
        // Hide check icon, show empty space
        icons.forEach(icon => {
          if (icon.tagName === 'svg') {
            icon.classList.add('hidden')
          } else if (icon.classList.contains('w-5')) {
            icon.classList.remove('hidden')
          }
        })
      }
    }
  }
}